import _createForOfIteratorHelper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module list/listproperties/listreversedcommand
 */
import { Command } from 'ckeditor5/src/core.js';
import { first } from 'ckeditor5/src/utils.js';
import { expandListBlocksToCompleteList, isListItemBlock } from '../list/utils/model.js';
/**
 * The list reversed command. It changes the `listReversed` attribute of the selected list items,
 * letting the user to choose the order of an ordered list.
 * It is used by the {@link module:list/listproperties~ListProperties list properties feature}.
 */
var ListReversedCommand = /*#__PURE__*/function (_Command) {
  _inherits(ListReversedCommand, _Command);
  var _super = _createSuper(ListReversedCommand);
  function ListReversedCommand() {
    _classCallCheck(this, ListReversedCommand);
    return _super.apply(this, arguments);
  }
  _createClass(ListReversedCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var value = this._getValue();
      this.value = value;
      this.isEnabled = value != null;
    }
    /**
     * Executes the command.
     *
     * @fires execute
     * @param options.reversed Whether the list should be reversed.
     */
  }, {
    key: "execute",
    value: function execute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var document = model.document;
      var blocks = Array.from(document.selection.getSelectedBlocks()).filter(function (block) {
        return isListItemBlock(block) && block.getAttribute('listType') == 'numbered';
      });
      blocks = expandListBlocksToCompleteList(blocks);
      model.change(function (writer) {
        var _iterator = _createForOfIteratorHelper(blocks),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var block = _step.value;
            writer.setAttribute('listReversed', !!options.reversed, block);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
    /**
     * Checks the command's {@link #value}.
     */
  }, {
    key: "_getValue",
    value: function _getValue() {
      var model = this.editor.model;
      var document = model.document;
      var block = first(document.selection.getSelectedBlocks());
      if (isListItemBlock(block) && block.getAttribute('listType') == 'numbered') {
        return block.getAttribute('listReversed');
      }
      return null;
    }
  }]);
  return ListReversedCommand;
}(Command);
export { ListReversedCommand as default };